<template>
  <div>
    <!-- <p style="color:#fff;">{{ content }}</p> -->
    <div class="home">
      <p class="test">{{ tips }}</p>
      <!-- <a class="iphone" href="/mobile/CLH4827RNTimg"></a>
      <a class="android" @click="toDownload"></a> -->
    </div>
    <!-- <div class="declaration">
      <p>
        The products and services that PPPokerPro offers (via its websites, tablet and mobile applications) are together referred to as the "<strong>Services</strong>".<br><br>
        Access to Services may not be legal for residents of, or persons located in, <a target="_blank" href="/mobile/countries">certain countries</a>. Services provided hereunder do not constitute an offer, solicitation or invitation by PPPokerPro for the use of, or subscription to, betting, gaming or other services in any jurisdiction in which such activities are prohibited by law. In particular, residents of or persons located in the United States shall not use any of the Services.
      </p>
    </div> -->
    <!-- <div class="footer">
      <p>PPPokerPro is a brand and registered business name, owned by AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IL12LD.</p>
      <br>
      <p>Regulated & Licensed by <a target="_blank" href="https://www.gov.im/categories/business-and-industries/gambling-and-e-gaming/licence-holders/">Isle of Man Gambling Supervision Commission</a> pursuant to the Online Gambling </p>
      <br>
      <p>Regulation Act 2001 since 24th July, 2019 (Last Renewal: 24th July, 2019).</p>
      <br>
      <p>Persons under the age of 18 are not allowed to create accounts and/or participate in gambling.</p>
      <br>
      <p>Any deposits or winnings with PPPokerPro are <a target="_blank" href="https://www.gov.im/categories/business-and-industries/gambling-and-e-gaming/player-protection/">secure</a> and can be enforced by Isle of Man law.</p>
      <br>
      <p class="link">
        <a target="_blank" href="/mobile/PrivacyPolicy">Privacy Policy</a> |
        <a target="_blank" href="/mobile/TermsOfService">Terms of Service</a>
      </p>
      <p class="link">Contact us by email: <a class="no_under" href="mailto:info@pppokerpro.com">info@pppokerpro.com</a></p>
      <p>©2019 PPPokerPro. All rights reserved.</p>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  data () {
    return {
      tips: '',
      content: {
        'sc': {
          p1: '已完成绑定，祝您游玩愉快',
          p2: '验证错误，请重新尝试'
        },
        'tc': {
          p1: '已完成綁定，祝您遊玩愉快',
          p2: '驗證失敗，請重新嘗試'
        },
        'en': {
          p1: 'Linked successfully. Good luck at the tables!',
          p2: 'Failed. Please try again later'
        },
        'ru': {
          p1: 'Успешно привязано. Удачи в игре!',
          p2: 'Не удалось, попробуйте позже'
        },
        'jp': {
          p1: 'バインドしました。幸運を祈ります！',
          p2: '失敗しました。後ほど再試行してください'
        },
        'es': {
          p1: 'Se vinculó correctamente. ¡Buena suerte en las mesas!',
          p2: 'Error. Inténtalo de nuevo más tarde.'
        },
        'th': {
          p1: 'เชื่อมต่อสำเร็จแล้ว ขอให้โชคดีในการเล่น!',
          p2: 'ไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง'
        },
        'hi': {
          p1: 'लिंक हो गया। खेल के लिए शुभकामनाएँ!',
          p2: 'विफल। कृपया बाद में फिर से कोशिश करें'
        },
        'pt': {
          p1: 'Vinculado com sucesso. Boa sorte nas mesas!',
          p2: 'Erro. Tente mais tarde.'
        },
        'tr': {
          p1: 'Başarıyla bağlandı. Masalarda bol şans dileriz!',
          p2: 'Başarısız. Lütfen daha sonra tekrar deneyin'
        },
        'kr': {
          p1: '연결되었습니다. 테이블에서 행운이 있길 바랍니다!',
          p2: '실패했습니다. 다시 시도하세요.'
        }
      }
    }
  },
  methods: {
  },
  created () {
    console.log(this.$route.query)
    this.tips = this.content[this.$route.query.lang]['p' + this.$route.query.status]
  }
}
</script>

<style>
  body, #app {
    background-color: #000000;
  }
  html, body, #app {
    height: 100%;
  }
</style>
<style lang="scss" scoped>
.home {
  position: relative;
  background: url('/mobile/static/img/activate/logo_pppokerpro.png') no-repeat center 60px;
  background-size: 380px auto;
  width: 750px;
  padding-top: 480px;
  background-color: #000;
  .test {
    position: relative;
    text-align: center;
    font-size: 32px;
    color: #fff;
    margin: 0px;
    padding: 0px 40px;
  }
  .iphone, .android {
    position: absolute;
    display: inline-block;
    background-size: 100%;
    width: 305px;
    height: 105px;
  }
  .iphone {
    top: 1050px;
    left: 55px;
    background-image: url('/mobile/static/img/guide/btn_download_ios.png');
  }
  .android {
    top: 1050px;
    right: 55px;
    background-image: url('/mobile/static/img/guide/btn_download_android.png');
  }
}
.declaration {
  position: relative;
  margin: 0;
  margin-top: -50px;
  padding-bottom: 30px;
  font-size: 20px;
  padding-top: 0;
  color: #ccc5c5;
  background-color: #000;
  p {
    line-height: 30px;
    margin: 0;
    padding: 0 70px;
    color: #ccc5c5;
    a {
      color: #ccc5c5;
      font-weight: bold;
      box-shadow: 0 2px;
      // text-decoration: underline;
      &:hover {
        color: #ccc5c5;
      }
    }
  }
}
.footer {
  position: relative;
  width: 100%;
  // height: 500px;
  left: 0px;
  bottom: 0px;
  font-size: 20px;
  background-color: #000;
  padding-top: 20px;
  padding-bottom: 30px;
  text-align: left;
  a {
    color: #E2E2E2;
  }
  p {
    line-height: 30px;
    margin: 0px;
    padding: 0 70px;
    color: #7a7878;
    a {
      color: #7a7878;
      box-shadow: 0 2px;
      font-weight: bold;
      // text-decoration: underline;
      &:hover {
        color: #7a7878;
      }
    }
  }
  .no_under {
    box-shadow: none;
  }
  .link a {
    color: #7a7878;
    &:hover {
      color: #fff;
    }
  }
}
</style>
